export default "__VITE_ASSET__DgRo1A1u__"